
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';
import filters from '@/filters';

import { JobFair } from '@/models/job.types';

import FileInput from '@/components/input/FileInput.vue';
import FileBannerInputJobsFair from '@/components/input/FileBannerInputJobsFair.vue';
import toast from '@/functions/toast.function';

@Component({
  components: {
    FileInput,
    FileBannerInputJobsFair,
  },
  filters,
})
export default class ModalJobsFair extends Vue {

  /* VUEX */

  // ACTION

  @Action('actionResetJobFair', { namespace: 'job' })
  private actionResetJobFair: any;
  @Action('actionCreateJobFairInformation', { namespace: 'job' })
  private actionCreateJobFairInformation: any;
  @Action('actionJobFairUpdate', { namespace: 'job' })
  private actionJobFairUpdate: any;

  // STATE

  @State('job_fair', { namespace: 'job' })
  private job_fair: JobFair;

  /* PROP */

  @Prop({ default: false })
  private isShow: boolean;
  @Prop({ default: false })
  private isStartJobsFair: boolean;
  @Prop({ default: '' })
  private status: string;

  /* INITIALIZATION */
  private is_data_correctly: boolean = false;

  // WATCHER

  @Watch('isShow')
  private onIsShowChanged() {
    if (this.isShow) {
      if (this.status === 'create') {
        this.is_data_correctly = true;
        this.actionResetJobFair();
      }
    }
  }

  private actionSubmit() {
    if (this.is_data_correctly) {
      toast.warning(this.$i18n.t('is_data_correctly'));
      return;
    }
    this.actionCreateJobFairInformation({
      params: null,
      success: (response: any) => {
        this.$emit('update:isShow', false);
        this.$emit('is-start');
      },
      fail: (response: any) => {
        // TODO
      },
    });
  }

  private actionUpdate() {
    this.actionJobFairUpdate({
      params: null,
      success: (response: any) => {
        // TODO
        this.$emit('update:isShow', false);
      },
      fail: (response: any) => {
        // TODO
      },
    });
  }

  private clickStartDateOnUpdate() {
    if (this.status !== 'create') {
      toast.warning(this.$t('warning_cannot_edit_startdate'));
    }
  }

  private isDataCorrectly(): void {
    const isTrue: boolean = !this.job_fair.name && !this.job_fair.description && !this.job_fair.period_end && !this.job_fair.poster && !this.job_fair.responsible_person && !this.job_fair.responsible_person_phone;

    if (isTrue) {
      this.is_data_correctly = true;
      return;
    }
    this.is_data_correctly = false;
    return;
  }

  private ristrictInputTextOnly(event: any) {
    const target = event.target;
    target.value = target.value.replace(/[^a-zA-Z]/g, '');
    this.job_fair.responsible_person = target.value;
  }

  private ristrictInputNumberOnly(event: any) {
    this.job_fair.responsible_person_phone = this.job_fair.responsible_person_phone.replace(/[^0-9+]/g, '');
    (this.$refs.picNumber as any).phone = this.job_fair.responsible_person_phone;
  }
}
